import {
  allCriteriaAnswered,
  allCriteriaOk,
  getArticleCompletionStatus,
} from "@coworker/app/src/components/TestBuy/CommonComponents/article.helpers";
import {
  Criterion,
  TestBuyProductWithCriteria,
} from "@coworker/types/lib/testbuy";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import crossCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossCircleIconPath";
import warningTrianglePath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/WarningTrianglePath";
import styles from "./item-criteria-status.module.css";
import { Trans } from "@coworker/locales";
import React from "react";
import checkmarkCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CheckmarkCircleIconPath";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";

interface ItemCriteriaStatusProps {
  testbuyItem: TestBuyProductWithCriteria;
}

export const ItemCriteriaStatus = ({
  testbuyItem,
}: ItemCriteriaStatusProps) => {
  const criteriaStatus = React.useMemo(() => {
    const getCriteriaStatusAndText = (allCriterias: Criterion[]) => {
      const articleStatus = getArticleCompletionStatus(testbuyItem);

      if (articleStatus === "Started" || articleStatus === "Completed") {
        if (allCriteriaAnswered(allCriterias) && !allCriteriaOk(allCriterias)) {
          const failedCriteriaCount = allCriterias.filter(
            (c) => c.state === "NOT_OK"
          ).length;
          return {
            icon: crossCircleIconPath,
            text: (
              <Trans count={`${failedCriteriaCount}/${allCriterias.length}`}>
                failedCountString
              </Trans>
            ),
            className: "failed",
          };
        } else if (allCriteriaOk(allCriterias))
          return {
            icon: checkmarkCircleIconPath,
            text: <Trans>passedString</Trans>,
            className: "passed",
          };
      } else if (articleStatus === "FollowUpTaskMissing") {
        return {
          icon: warningTrianglePath,
          text: <Trans>createFollowUpTaskString</Trans>,
          className: "warning",
        };
      }
      return {
        icon: undefined,
        text: "",
        className: "",
      };
    };
    return getCriteriaStatusAndText(testbuyItem.criteria || []);
  }, [testbuyItem]);

  return (
    <>
      {criteriaStatus.text && (
        <>
          <Spacer />
          <div
            className={`${styles["item-status-root"]} ${criteriaStatus.className ? ` ${styles[criteriaStatus.className]}` : ""}`}
          >
            {
              <>
                {criteriaStatus.icon && (
                  <FixaSSRIcon paths={criteriaStatus.icon} />
                )}
                <span
                  className={
                    criteriaStatus.className
                      ? `${styles["bold-text"]} ${styles[criteriaStatus.className]}`
                      : styles["bold-text"]
                  }
                >
                  {criteriaStatus.text}
                </span>
              </>
            }
          </div>
        </>
      )}
    </>
  );
};
